export default "__VITE_ASSET__ClnBw6ut__"